module.exports = __webpack_public_path__ + "media/images/powerpoint/bouygues-telecom-background-8ec3a6a598d475e074930a21da2e2a56.png";